import { render, staticRenderFns } from "./accountOfficer.vue?vue&type=template&id=fdead892&scoped=true"
import script from "./accountOfficer.vue?vue&type=script&lang=js"
export * from "./accountOfficer.vue?vue&type=script&lang=js"
import style0 from "./accountOfficer.vue?vue&type=style&index=0&id=fdead892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdead892",
  null
  
)

export default component.exports